import React from 'react';

export const StakeholderMapQuadrants: React.FC = () => {
  return (
    <>
      {/* Quadrant backgrounds */}
      <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 pointer-events-none">
        <div className="bg-amber-50/60 border-b border-r border-slate-200" />
        <div className="bg-green-50/60 border-b border-slate-200" />
        <div className="bg-slate-50/60 border-r border-slate-200" />
        <div className="bg-blue-50/60" />
      </div>

      {/* Axis lines — CSS 50% so they are always centred regardless of canvas size */}
      <div className="absolute pointer-events-none inset-y-0" style={{ left: '50%', width: 1, background: '#cbd5e1' }} />
      <div className="absolute pointer-events-none inset-x-0" style={{ top: '50%', height: 1, background: '#cbd5e1' }} />

      {/* Quadrant labels */}
      <div className="absolute top-3 left-3 pointer-events-none">
        <p className="text-[10px] font-bold text-amber-600">C — Build Confidence</p>
        <p className="text-[9px] text-amber-500">High influence · Low readiness</p>
      </div>
      <div className="absolute top-3 right-3 text-right pointer-events-none">
        <p className="text-[10px] font-bold text-green-600">H — Activate as Amplifiers</p>
        <p className="text-[9px] text-green-500">High influence · High readiness</p>
      </div>
      <div className="absolute bottom-8 left-3 pointer-events-none">
        <p className="text-[10px] font-bold text-slate-500">R — Inform and Reassure</p>
        <p className="text-[9px] text-slate-400">Low influence · Low readiness</p>
      </div>
      <div className="absolute bottom-8 right-3 text-right pointer-events-none">
        <p className="text-[10px] font-bold text-blue-600">E — Engage and Enable</p>
        <p className="text-[9px] text-blue-500">Low influence · High readiness</p>
      </div>
    </>
  );
};
